/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MigrationRequest } from '../../models/migration-request';
import { MigrationResult } from '../../models/migration-result';

export interface ApiRequestMigrationAllPost$Params {
      body?: MigrationRequest
}

export function apiRequestMigrationAllPost(http: HttpClient, rootUrl: string, params?: ApiRequestMigrationAllPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationResult>> {
  const rb = new RequestBuilder(rootUrl, apiRequestMigrationAllPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MigrationResult>;
    })
  );
}

apiRequestMigrationAllPost.PATH = '/api/Request/Migration/All';
